import { Component, Injector, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { DocumentPreviewComponent } from 'src/app/components/document-preview/document-preview.component';
import { EditableFormComponent } from 'src/app/components/editable-form/editable-form.component';
import { ToolbarButton } from 'src/app/components/toolbar/toolbar.component';
import { DocumentoDaoService } from 'src/app/dao/documento-dao-service';
import { Documento } from 'src/app/models/documento.model';
import { PageFrameBase } from 'src/app/modules/base/page-frame-base';
import { LookupItem } from 'src/app/services/lookup.service';

@Component({
  selector: 'documentos-preview',
  templateUrl: './documentos-preview.component.html',
  styleUrls: ['./documentos-preview.component.scss']
})
export class DocumentosPreviewComponent extends PageFrameBase {
  @ViewChild(DocumentPreviewComponent, { static: false}) documentPreview?: DocumentPreviewComponent;
  @ViewChild("tokenForm", { static: false }) public tokenForm?: TemplateRef<any>;
  @Input() documentoId?: string;
  @Input() documento?: Documento | null;

  public documentoSalvo: boolean = false;
  public acessoExterno: boolean = false;

  public documentoDao: DocumentoDaoService;
  public buttons: ToolbarButton[] = [
    { icon: "bi bi-floppy", hint: "Salvar documento", color: "btn-outline-info border-0",onClick: this.salvar.bind(this) },
    { icon: "bi bi-printer", hint: "Imprimir", color: "btn-outline-secondary border-0", onClick: this.imprimir.bind(this) },
    { icon: "bi bi-envelope-at", hint: "Enviar E-mail", color: "btn-outline-warning border-0" },
    { icon: "bi bi-file-earmark-pdf", hint: "Exportar PDF", color: "btn-outline-danger border-0", onClick: this.geraPDF.bind(this) },
    { icon: "bi bi-whatsapp", hint: "Enviar WhatsApp", color: "btn-outline-success border-0", onClick: this.enviarWhatsApp.bind(this) }
  ];

  constructor(public injector: Injector) {
    super(injector);
    this.documentoDao = injector.get<DocumentoDaoService>(DocumentoDaoService);
    this.modalWidth = 1000;
    this.form = this.fh.FormBuilder({
      conteudo: { default: "" },
      token: { default: "" }
    }, this.cdRef, this.validate);
    if (this.gb.isEmbedded) this.buttons.push({ img: "assets/images/sei_icon.png", hint: "Enviar SEI", color: "btn-outline-primary border-0", onClick: this.adicionarDocumentoSei.bind(this) })
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    (async () => {
      let self = this;
      this.acessoExterno = !!this.queryParams?.documento_id;
      this.documentoId = this.documentoId || this.metadata?.documentoId || this.queryParams?.documento_id || this.urlParams?.get("documentoId");
      let token = this.queryParams?.token;
      if(this.acessoExterno) {
        if(!token?.length) {
          let result = await this.dialog.template({ title: "Informe o token", modalWidth: 500 }, this.tokenForm!, [
            {
              label: "Confirmar",
              icon: "bi bi-check-circle",
              color: "btn-outline-success",
              value: "CONFIRMAR",
              disabled: this.confirmarTokenDisabled.bind(this)
            }, {
              label: "Cancelar",
              icon: "bi bi-dash-circle",
              color: "btn btn-outline-danger",
              value: "CANCELAR"
            }
          ]).asPromise();
          if (result.button.value == "CONFIRMAR") token = this.form!.controls.token.value;
          result.dialog.close();
        }
      }
      this.loading = true;
      try {
        if(this.acessoExterno) {
          if(!token?.length) {
            this.error("Impossível consultar o documento sem informar o token");
          } else {
            try {
              this.documento = await this.documentoDao.getDocumentoAcessoExterno(this.documentoId!, token);
            } catch (error) {
              this.error(error);
            }
          }
        } else {
          this.documento = this.documento || this.metadata?.documento || null;
          if(!this.documento) this.documento = await this.documentoDao.getById(this.documentoId!);
          if(!this.documento) this.error("Erro ao tentar carrregar documento");
        }
        let rodape = this.documento?._metadata?.rodape;
        if(rodape?.length && !this.documento!.conteudo?.includes(rodape)) {
          this.documento!.conteudo = this.documento!.conteudo?.concat(rodape) || null;
        }
        this.cdRef.detectChanges();
      } finally {
        this.loading = false;
      }
    }).bind(this)();
  }

  public validate = (control: AbstractControl, controlName: string) => {
    let result = null;
    return result;
  }

  public adicionarDocumentoSei() {
    this.go.navigate({ route: ['documentos', 'adicionar-sei', this.documento!.id] }, { metadata: { documento: this.documento } });
  }

  public enviarWhatsApp() {
    this.dialog.alert("Indiponível", "Recurso indisponível no momento!");
  }

  public confirmarTokenDisabled(): boolean {
    return (this.form!.controls.token?.value?.length || 0) != 8;
  }

  salvar() {
    if (this.documento) this.util.writeToFile("documento_" + this.documento.numero, this.documento.conteudo!, "text/html");
    /*let element = document.createElement('a');
    const blob = new Blob([this.documento.conteudo!], {type: "text/html"}) // Create a blob (file-like object)
    const url = URL.createObjectURL(blob) // Create an object URL from blob
    element.setAttribute('href', url) // Set "a" element link
    //element.setAttribute('href', 'data:text/html;charset=utf-8;base64,' + btoa(this.documento.conteudo!));
    element.setAttribute('download', 'documento_' + this.documento.numero);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);*/
  }

  geraPDF() {
    if (this.documento) {
      this.documentoDao.gerarPDF(this.documento.id).then(res => {
        // TODO: Retornar arquivo para download
      });
    }
  }

  imprimir() {
    // TODO: Imprimir somente o conteúdo do documento
    this.documentPreview?.print();
    //window.print();
  }
}

